module.exports = __webpack_public_path__ + "static/ISE-13dfafc6ad34805dbc5f2852e00b8841.png";